export default (url = '') => url.startsWith('http://') || url.startsWith('https://');
